module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M9 6C9 7.65685 7.65685 9 6 9 4.34315 9 3 7.65685 3 6 3 4.34315 4.34315 3 6 3 7.65685 3 9 4.34315 9 6zM17 6C17 7.65685 15.6569 9 14 9 12.3431 9 11 7.65685 11 6 11 4.34315 12.3431 3 14 3 15.6569 3 17 4.34315 17 6zM12.9291 17C12.9758 16.6734 13 16.3395 13 16 13 14.3648 12.4393 12.8606 11.4998 11.6691 12.2352 11.2435 13.0892 11 14 11 16.7614 11 19 13.2386 19 16V17H12.9291zM6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
